module.exports = __webpack_public_path__ + "static/img/app-main-img01@t.814620d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ing-life/app-main-img01@t.png
// module id = uH0D
// module chunks = 0